import { render, staticRenderFns } from "./CandidateInfoPage.vue?vue&type=template&id=c3ae8b5e&"
import script from "./CandidateInfoPage.vue?vue&type=script&lang=js&"
export * from "./CandidateInfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports